import { useAuth } from '../auth/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import Subscription from './SubTemplate';
import WATemplate from './WATemplate';
import DupSubscription from './DupSubTemplate';

const Dashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { section } = useParams();

  const activeTab = section || 'subscription';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleTabChange = (tab) => {
    navigate(`/dashboard/${tab}`);
  };

  const renderComponent = () => {
    switch (activeTab) {
      case 'dupSubTemplate':
        return <DupSubscription/>
      case 'waTemplate':
        return <WATemplate />;
      case 'subscription':
      default:
        return <Subscription />;
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white p-4 space-y-4">
        <h2 className="text-xl font-bold mb-6">Menu</h2>
        <button
          onClick={() => handleTabChange('subscription')}
          className={`block w-full text-left px-3 py-2 rounded ${
            activeTab === 'subscription' ? 'bg-gray-700' : 'hover:bg-gray-700'
          }`}
        >
          Subscription Templates
        </button>
        <button
          onClick={() => handleTabChange('waTemplate')}
          className={`block w-full text-left px-3 py-2 rounded ${
            activeTab === 'waTemplate' ? 'bg-gray-700' : 'hover:bg-gray-700'
          }`}
        >
          WA Templates
        </button>
        <button
          onClick={() => handleTabChange('dupSubTemplate')}
          className={`block w-full text-left px-3 py-2 rounded ${
            activeTab === 'dupSubTemplate' ? 'bg-gray-700' : 'hover:bg-gray-700'
          }`}
        >
          Duplicate Subscription Templates
        </button>
      </div>

      {/* Main content */}
      <div className="flex-1 p-6 relative">
        {/* Logout button */}
        <div className="absolute top-4 right-6">
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Logout
          </button>
        </div>

        {/* Component content */}
        {renderComponent()}
      </div>
    </div>
  );
};

export default Dashboard;
